import styled from 'styled-components';

const Container = styled.div`
	background-color: white;
	position: absolute;
	top: 60px;
	right: 350px;
	width: calc(100vw - 350px);
	height: calc(100vh - 60px);
	z-index: 9;
	padding: 40px 0 0 40px;
	display: flex;
	flex-direction: column;
`;

const ItemsContainer = styled.div`
	display: flex;
	overflow-y: auto;
	flex-direction: row;
	flex-wrap: wrap;
	padding: 10px 0 40px;
`;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-self: center;
	align-items: center;
	justify-items: center;
	width: calc(20% - 32px);
	margin: 0 16px 32px 16px;
	background-color: ${props => props.selected ? 'rgb(74, 144, 226, 0.1)' : 'rgba(0,0,0,0)'};
	border-radius: 4px;
	transition: background-color 0.2s ease-out;
`;

const Item = styled.div`
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  background-color: white;
	margin: 0;
	z-index: 1;
	background-color: white;
	box-shadow:
		0px 4px 8px -2px ${props => props.selected ? '#4A90E2' : 'rgba(0,0,0,0)'},
		0px 0px 0px 2px ${props => props.selected ? '#4A90E2' : 'rgba(0,0,0,0)'},
		0px 0px 1px 3px ${props => props.selected ? '#4A90E2' : 'rgba(0,0,0,0)'} inset;
	transform: translate(0px, 0px) scale(1);
  transition: all 0.2s ease-out;
	overflow: hidden;
	display: block;
	width: 100%;
	cursor: pointer;

	&:hover {
		box-shadow:
		0px 4px 8px -2px ${props => props.selected ? '#4A90E2' : 'rgba(0,0,0,0)'},
		0px 0px 0px 2px #4A90E2,
		0px 0px 1px 3px ${props => props.selected ? '#4A90E2' : 'rgba(0,0,0,0)'} inset;
	}
}
`;

const InputContainer = styled.div`
	padding: 0 0 1rem;
`;

export {
	Container,
	ItemsContainer,
	Wrapper,
	Item,
	InputContainer,
}
